import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/**
 * Avatar à initiales — la fonction initials() était réécrite dans 6 fichiers.
 * Les initiales sortent du label : « Olivia Martin » → OM, « o.martin@x.io » → OM
 * (les deux premiers segments avant l'@), fallback « ? ».
 */
@Component({
  selector: 'wh-avatar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="bg-primary-100 text-primary-700 dark:bg-primary-500/20 dark:text-primary-300 flex shrink-0 items-center justify-center rounded-full font-semibold"
      [class]="sizeClass()">
      {{ initials() }}
    </span>
  `,
})
export class WhAvatarComponent {
  /** Nom complet ou email — la matière des initiales. */
  readonly label = input.required<string>();
  readonly size = input<'sm' | 'md'>('md');

  protected readonly sizeClass = computed(() => (this.size() === 'sm' ? 'size-7 text-[10px]' : 'size-9 text-xs'));

  protected readonly initials = computed(() => {
    const label = this.label().trim();
    if (!label) return '?';
    const source = label.includes('@') ? label.split('@')[0] : label;
    const parts = source.split(/[\s._-]+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  });
}
